module.exports = __webpack_public_path__ + "static/clear-and-simple-as-the-truth-46bc2d256b9a95ed5bb43c7b5175f742.jpg";